import React from 'react';
import PageContainer from '../../components/global/PageContainer';
import { withAuthorization, withOrganization } from '../../components/Session';
import AddAudioForm from '../../components/AddAudioForm';
import { withFirebase } from '../../components/Firebase';

const AddAudio = (props: any) => (
  <PageContainer>
    <AddAudioForm firebase={props.firebase} />
  </PageContainer>
);

// Only check that user is authenticated - org role check is handled by withOrganization
// and the Navigation component already hides this link for non-ADMIN/OPERATOR users
const condition = (authUser: any) => !!authUser;
export default withOrganization(withAuthorization(condition)(withFirebase(AddAudio)));
